module.exports = __webpack_public_path__ + "img/centerCensus5.4458eb2f.png";